import React, { useEffect } from 'react'
import { Outlet, useParams } from 'react-router'
import { useAppDispatch } from './redux/hooks'
import { appBoot } from './redux/thunk/appBoot'
import { setBearerToken } from './redux/appSlice'
import { DateTime } from 'luxon'

export const AppBooter = React.memo(props => {
	const { token, encounterGuid, branchGuid } = useParams()
	const dispatch = useAppDispatch()
	useEffect(() => {
		// if a token is specified in the url (e.g. docgen print jobs)
		// set it before booting
		if(token) {
			// console.debug(`appBooter token ${token}`)
			dispatch(setBearerToken({
				token,
				expiredAt: DateTime.now().plus({hours: 1}).toMillis(),
			}))
		}
		// if an encounterGuid (docgen print jobs) or a branchGuid (branch
		// preview) is set in the url, assume the handling route will perform
		// the initial sync
		dispatch(appBoot({
			performInitialSync: !encounterGuid && !branchGuid,
		}))
	}, [])
	return <Outlet />
})
